import React, { useState, useEffect } from 'react';
import { Skeleton, Table } from 'antd';

export default function TableWithSkeleton({ rowSelection, columns, data, loading, length = 10, onChange, page = 1, pageSize = 10 }) {

    const [tableData, setTableData] = useState();
    // let filterColumns = columns?.filter((item) => !hiddenColumns?.includes(item?.title));
    const numberColumn = {
        title: "No.",
        dataIndex: "no",
        render: (text, __, index) => {
            return loading ? text : <span className='ps-2'>{(page - 1) * pageSize + (index + 1)}</span>;
        },
        width: 80,
    };

    const newColumns = !loading ? [numberColumn, ...columns] : columns;

    useEffect(() => {
        let skeletonObj = new Object();
        columns.map((item) => {
            skeletonObj[item?.dataIndex] = <Skeleton.Input className='table-skeleton' active={true} />;
        })
        setTableData(Array.from({ length: length }, v => skeletonObj));
    }, []);

    const rowClassName = (record) => {
        return record?.isAdminCommission ? 'admin-commission-row' : '';
    };

    return (
        <Table className='table-responsive'
            scroll={{ x: true }} rowSelection={rowSelection}
            sortDirections={false} columns={newColumns} dataSource={loading ? tableData : data}
            pagination={false} onChange={onChange}
            rowClassName={rowClassName}
        />
    )
}
